module.exports = __webpack_public_path__ + "static/media/white-arrow.8a3b2e30.svg";